import axios from "./axios";

export interface AdminAlertItem {
  id: string;
  title: string;
  message: string;
  tone: "info" | "success" | "warning" | "danger";
  audience: "all" | "guest" | "authenticated" | "creator" | "moderator" | "admin";
  targetUrl?: string | null;
  isActive: boolean;
  isDismissible: boolean;
  showOnHome: boolean;
  showOnReader: boolean;
  showOnCreator: boolean;
  showOnGlobal: boolean;
  startAtUtc: string;
  endAtUtc?: string | null;
  priority: number;
  createdAtUtc: string;
  updatedAtUtc: string;
}

export type AdminAlertPayload = Omit<
  AdminAlertItem,
  "id" | "createdAtUtc" | "updatedAtUtc" | "startAtUtc" | "endAtUtc"
> & { startAtUtc: string; endAtUtc?: string | null };

export async function getAdminAlerts(): Promise<AdminAlertItem[]> {
  try {
    const res = await axios.get("/admin/alerts");
    return Array.isArray(res.data) ? (res.data as AdminAlertItem[]) : [];
  } catch (error) {
    console.error("getAdminAlerts error", error);
    return [];
  }
}

export async function createAdminAlert(payload: AdminAlertPayload): Promise<AdminAlertItem | null> {
  try {
    const res = await axios.post("/admin/alerts", payload);
    return (res.data ?? null) as AdminAlertItem | null;
  } catch (error) {
    console.error("createAdminAlert error", error);
    return null;
  }
}

export async function getAdminAlertById(id: string): Promise<AdminAlertItem | null> {
  try {
    const res = await axios.get(`/admin/alerts/${id}`);
    return (res.data ?? null) as AdminAlertItem | null;
  } catch (error) {
    console.error("getAdminAlertById error", error);
    return null;
  }
}

export async function updateAdminAlert(id: string, payload: AdminAlertPayload): Promise<AdminAlertItem | null> {
  try {
    const res = await axios.put(`/admin/alerts/${id}`, payload);
    return (res.data ?? null) as AdminAlertItem | null;
  } catch (error) {
    console.error("updateAdminAlert error", error);
    return null;
  }
}

export async function deleteAdminAlert(
  id: string,
  options?: { hardDelete?: boolean; confirmHardDelete?: boolean; reason?: string },
): Promise<boolean> {
  const payload = {
    hardDelete: Boolean(options?.hardDelete),
    confirmHardDelete: Boolean(options?.confirmHardDelete),
    reason: options?.reason ?? "admin-alert-delete",
  };

  try {
    await axios.delete(`/admin/alerts/${id}`, { data: payload });
    return true;
  } catch (error) {
    console.error("deleteAdminAlert error", error);
    return false;
  }
}
